// extracted by mini-css-extract-plugin
export default {"wrapper":"PayerTypes_wrapper__waz+g","container":"PayerTypes_container__EZYGW","system_mismatch":"PayerTypes_system_mismatch__F+jad","label":"PayerTypes_label__Kgcem"};